
'use client';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle, PackageSearch } from 'lucide-react';
import { packageTiers, type PackageTier } from '@/lib/packages';
import CalendlyBadge from '@/components/CalendlyBadge';



export function AllPackagesSection() {
  return (
    <section className="py-12 sm:py-16 bg-muted/50 w-full">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
           <PackageSearch className="h-12 w-12 text-primary mx-auto mb-4" />
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl font-headline">
            Explore Our Service Packages
          </h2>
          <p className="mt-4 text-lg leading-8 text-muted-foreground">
            Choose the perfect plan to optimize your website and achieve your goals.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 items-stretch">
          {packageTiers.map((tier) => (
            <Card 
              key={tier.name} 
              className="flex flex-col shadow-lg transition-all duration-300 ease-in-out hover:shadow-xl w-full"
            >
              <CardHeader className="items-center text-center">
                {tier.icon}
                <CardTitle className="text-xl font-headline mt-2">{tier.name}</CardTitle>
                <CardDescription className="text-2xl font-bold text-primary mt-1">{tier.price}</CardDescription>
                {tier.renewal && <p className="text-xs text-muted-foreground">{tier.renewal}</p>}
              </CardHeader>
              <CardContent className="flex flex-col flex-grow">
                <p className="text-sm text-muted-foreground mb-4 text-center min-h-[60px]">{tier.description}</p>
                <ul className="space-y-2 text-sm mb-6 flex-grow">
                  {tier.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <CheckCircle className="h-4 w-4 mr-2 mt-0.5 text-green-500 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                {tier.discountNote && <p className="text-xs text-accent text-center mb-3 font-semibold">{tier.discountNote}</p>}
                <div className="w-full flex justify-center">
                  <Button size="lg"  onClick={() => document.getElementsByClassName('calendly-badge-content')[0].click()}>
                    {tier.ctaText || 'Book a Consultation'}
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
